import Vue from "vue"
import Meta from "vue-meta"
import Router from "vue-router"
import Competition from "@/views/Competition.view.vue"
import Competitions from "@/views/Competitions.view.vue"
import Archival from "@/views/Archival.view.vue"
import Live from "@/views/Live.view"

Vue.use(Router)

Vue.use(Meta, {
  refreshOnceOnNavigation: true,
})

const routes = [
  {
    path: "/",
    name: "Competitions",
    component: Competitions,
  },
  {
    path: "/archiwum",
    name: "Archival",
    component: Archival,
  },
  {
    path: "/ankieta",
    // eslint-disable-next-line no-unused-vars
    beforeEnter(to, from, next) {
      window.location.href = "https://forms.gle/AMXdnzXXNHEjTfzZ6"
    },
  },
  {
    path: "/:competition",
    component: Competition,
    name: "Competition",
  },
  {
    path: "/archiwum/:competition",
    component: Competition,
    name: "ArchivalCompetition",
    meta: {
      archival: true,
    },
  },
  {
    path: "/:competition/live",
    component: Live,
    name: "Live",
    meta: {
      hideHeader: true,
      hideFooter: true,
    },
  },
  {
    path: "/:competition/live/:stage",
    component: Live,
    name: "LiveStage",
    meta: {
      hideHeader: true,
      hideFooter: true,
    },
  },
]

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "is-active",
  linkExactActiveClass: "is-exact-active",
  routes,
})
